import React from "react"

import HintPopover from "../../../../gd-ui/hint-popover/hint-popover"
import FieldMultiselect from "../../multiselect/multiselect"
import {FieldGoalListEditableProps} from "../../../render/goal-list/goal-list-editable"
import {FieldPickerType} from "../../../render/picker";

type Props = {
    field: FieldMultiselect
} & FieldGoalListEditableProps

export default class FieldAssignees_GoalListEditable extends React.Component<Props,any> {

    public previousOptions  : any

    constructor(props:Props) {
        super(props);

        const value = this.props.model[this.props.field.fieldId]

        this.state = {
            initialPropsValue   : value, // required to check if currentOptions update needed on props changed
            currentOptions      : value,
            showPopover         : false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId] // new value

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentOptions      : value
            }
        }

        return null // no changes
    }

    showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any, hidePopover: boolean = false) => {
        let currentOptions = this.state.currentOptions ? this.state.currentOptions.slice() : [];
        this.previousOptions = currentOptions;

        if (!!option.isAllValuesOption) {
            // all values option click
            currentOptions = null;
        } else {
            currentOptions = gd.utils.toggleArrayValue(currentOptions, option.value);
        }

        // clear outdated values (removed from options) if any from currentOptions
        let options = this.props.field.getOptions()?.slice()
        if (options) {
            const availableValues = _.map(options, option=>option.value)
            currentOptions = _.intersection(currentOptions, availableValues)
        }

        this.setState({
            currentOptions: currentOptions
        }, () => {
            if (hidePopover) this.hidePopover()
            // if (this.props.onChange) this.props.onChange(currentOptions);
            if (this.props.onChange) this.props.onChange(currentOptions, this.onCancelChange);
        });
    }

    onCancelChange = () => {
        this.setState({
            currentOptions: this.previousOptions
        });
    }

    render() {
        const {field} = this.props

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        })

        const selectedOptions = this.props.field._getOptions(this.state.currentOptions)

        const showHint = _.get(this.props.configOptions, 'showHint', true)

        // need check value because of none
        if (!!selectedOptions && selectedOptions.length > 0) {
            return (
                <field.components.PickerValueNotEmpty {...this.props}
                                                      className = {classes}
                                                      type      = {FieldPickerType.CIRCLE}
                                                      field     = {field}
                                                      options   = {selectedOptions}
                                                      onClick   = {this.showPopover}
                                                      onDelete  = {this.onOptionClick}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                    {!this.state.showPopover && showHint && <HintPopover parent={this} hint={this.props.field.label}/>}
                </field.components.PickerValueNotEmpty>
            )
        }

        // no value
        return (
            <field.components.PickerValueEmpty {...this.props}
                                               className    = {classes}
                                               type         = {FieldPickerType.CIRCLE}
                                               field        = {this.props.field}
                                               options      = {selectedOptions}
                                               onClick      = {this.showPopover}>
                {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                {!this.state.showPopover && showHint && <HintPopover parent={this} hint={this.props.field.label}/>}
            </field.components.PickerValueEmpty>
        )
    }
}

